import { useQuery } from 'hooks/useQuery'

import { fetchUsersByUsernames } from 'utils/queries'

import { UserType } from 'types/user'

import { useDiscoverContent } from './useDiscoverContent'

/**
 * Retrieves the User for each Top Coach as specified in the DiscoverContent entry in the DB.
 * @returns a query for an array of users.
 */
export const useTopCoaches = () => {
  const { data: discoverContent } = useDiscoverContent()

  if (!discoverContent) {
    console.error('No DiscoverContent in the database.')
  }

  const topCoachUsernames = discoverContent ? discoverContent.sections[2].tags : []

  const coachPromises = fetchUsersByUsernames(topCoachUsernames)

  return useQuery<Array<UserType | null>>(['users', ...topCoachUsernames], () => coachPromises)
}
